<template>
    <div style="background-color: #f2f2f2;height: 100%;" class="InstitutionArg">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            折扣设置
        </div>
        <div style="padding: 20px;"> 

            <div>

                <el-row>
                    <el-button type="primary" :disabled="disabledAdd" @click.native="toggleModalAdd">添加</el-button>
                    <el-button type="success" :disabled="disabledEdit"  @click="toggleModalEdit">编辑</el-button>
                    <div style="float:right">
                        <el-select
                            v-model="status"
                                style="margin:0 10px;width:200px"
                            placeholder="请选择状态">
                            <el-option
                                v-for="item in statusValue"
                                :key="item[0]"
                                :label="item[1]"
                                :value="item[0]">
                            </el-option>
                        </el-select>
                        <el-button type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </div>
                </el-row>
                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>
                    <el-table
                    :data="tableData"
                    border
                    :height="th"
                    v-loading="loading"
                    highlight-current-row 
                    @row-click='rowClick'
                    style="width: 100%">
                    <el-table-column
                        prop="name"
                        label="折扣名称"
                        >
                    </el-table-column>
                    <el-table-column label="折扣值(%)" prop="discount">
                        <template slot-scope="scope">
                            <div v-for="item in 5" :key="item">
                                <span v-if="scope.row[item>1?'discount'+item:'discount']>0">{{scope.row[item>1?'discount'+item:'discount']/100+'%'}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="discountType"
                        label="折扣类型"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.discountType==='room'">床位折扣</span>
                            <span v-if="scope.row.discountType==='nursing'">护理等级折扣</span>
                            <span v-if="scope.row.discountType==='other'">自添加项目折扣</span>
                            <span v-if="scope.row.discountType==='all'">总费用折扣</span>
                            <span v-if="scope.row.discountType==='all2'">总费用二次折扣</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="needVerify"
                        label="是否审核"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.needVerify==0">不审核</span>
                            <span v-if="scope.row.needVerify==1">审核</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="startTime" :formatter="formatterTime" label="折扣开始时间"></el-table-column>
                    <el-table-column prop="endTime" :formatter="formatterTime" label="折扣结束时间"></el-table-column> -->
                    <el-table-column
                        prop="status"
                        label="状态"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.status==1">正常</span>
                            <span v-if="scope.row.status==2">废弃</span>
                        </template>
                    </el-table-column>
                    </el-table>
                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>
                </template>
            </div>
        </div>
        <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import Add from "./Add";
    import Edit from "./Edit";
    import {getStaffCode,getMenuButton} from "@/utils/auth";

    export default {
        name: "Page",
        data(){
            return{
                loading:true,
                disabledAdd:true,
                menuButtonList:null,
                th:0,
                row:null,
                showModalAdd:false,
                showModalInfo:false,
                showModalEdit:false,
                disabledEdit:true,
                tableData:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                status:1,
                statusValue:[[-1,'全部'],[1,'正常'],[2,'废弃']]
            }
        },
        components:{
            Add,Edit
        },
        created(){
            this.getList();
            this.getMenu();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{
             getMenu(){
                let list = JSON.parse(window.localStorage.getItem("listMenuDTO"));
                var menu = getMenuButton(list,this.$route.path);
                this.menuButtonList = JSON.stringify(menu);
                if(menu!=null&&menu.length>0){
                    for(let i=0;i<menu.length;i++){
                        if(menu[i].buttonName=="添加"){
                            this.disabledAdd = false;
                        }
                    }
                }
            },
            formatterTime(row, column, cellValue) {
                return cellValue?cellValue.replace('T',' ').slice(0,19):null
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            getList(){
                this.loading = true;
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"InstitutionDiscount/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        status: this.status,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    this.loading = false;
                    this.disabledEdit=true;
                    if(response.data.error == 0){
                        console.log(response.data);
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            toggleModalEdit(){
                this.showModalEdit = !this.showModalEdit;
                this.$refs.myEdit.init(this.row);
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            rowClick(row){
                 this.row = row;
                if(this.menuButtonList.indexOf("编辑")!=-1){
                    this.disabledEdit =false;
                }
            }



        }
    }
</script>

<style lang="scss" scoped>
    /deep/ .el-table__body tr.current-row>td {
        background-color: #409EFF;
        color:#fff;
    }
</style>
